import api from './api';
import { IUser } from '../types';

export const userService = {
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  getUserById: async (id: string) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  createUser: async (userData: Partial<IUser>) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  updateUser: async (id: string, userData: Partial<IUser>) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  deleteUser: async (id: string) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  regenerateLicense: async (id: string, validUntilDate?: string) => {
    const response = await api.post(`/users/${id}/regenerate-license`, { validUntilDate });
    return response.data;
  },

  toggleUserStatus: async (id: string, reason?: string) => {
    const response = await api.post(`/users/${id}/toggle-status`, { reason });
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string) => {
    const response = await api.post('/users/change-password', { currentPassword, newPassword });
    return response.data;
  },

  setPassword: async (password: string) => {
    const response = await api.post('/users/set-password', { password });
    return response.data;
  }
};
